var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.4297 0.0388981C0.185465 0.108207 0.000121534 0.358261 0.000121534 0.618501C0.000121534 0.882665 -0.0730476 0.799824 3.37127 4.43643C5.38543 6.5631 6.67384 7.90236 6.74143 7.93964C6.81384 7.97957 6.90175 8 7.00129 8C7.10082 8 7.18874 7.97957 7.26114 7.93964C7.32873 7.90236 8.61714 6.5631 10.6313 4.43643C13.1773 1.74827 13.9041 0.96516 13.9473 0.863765C14.0161 0.70189 14.0176 0.537448 13.9516 0.387664C13.8256 0.101368 13.5731 -0.0324883 13.2797 0.0314247C13.1434 0.0610872 13.1118 0.0932889 10.0717 3.29725L7.00129 6.53309L3.93091 3.29725L0.860537 0.0613758L0.715594 0.0297512C0.63586 0.0123518 0.568161 -0.00100783 0.565152 5.979e-05C0.562116 0.00115627 0.501174 0.0186133 0.4297 0.0388981Z",
    fill: "#2F4352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.db9eef02db70ef1b4561fa6181a1a080.svg";
export { ForwardRef as ReactComponent };